import copy from "copy-to-clipboard";
import "./style.css";

export default class Team {
  static selector = ".team";

  constructor(block) {
    this.block = block;

    let phones = this.block.querySelectorAll(".team__member-contact--phone");
    phones.forEach(contact => {
      contact.addEventListener("click", this.onPhoneClicked);
    });

    let emails = this.block.querySelectorAll(".team__member-contact--email");
    emails.forEach(contact => {
      contact.addEventListener("click", this.onEmailClicked);
    });
  }

  onPhoneClicked = event => {
    let phoneElement = event.currentTarget;

    phoneElement.classList.add("copied");
    setTimeout(() => {
      phoneElement.classList.remove("copied");
    }, 480);

    const value = phoneElement.querySelector(".team__member-contact-inner span")
      .innerHTML;
    copy(value);
  };

  onEmailClicked = event => {
    const emailElement = event.currentTarget;

    const name = emailElement.parentNode.parentNode.querySelector(
      ".team__member-name"
    ).innerText;

    document.querySelector(
      "#talk-to-us #talk-message"
    ).placeholder = `Send a message to ${name}`;
    document.querySelector(
      "#talk-to-us #talk-contact"
    ).value = emailElement.getAttribute("data-contact");
  };
}
